import { ProductType } from '../globalTypes';
var GeoTreeHelper = /** @class */ (function () {
    function GeoTreeHelper() {
    }
    GeoTreeHelper.getAllDestinationsNodeId = function (productType) {
        switch (productType) {
            case ProductType.PACKAGE:
                //return 3534285;
                return 12454591;
            case ProductType.HOTEL:
                //return 4742421;
                return 12456957;
            case ProductType.RAIL_PACKAGE:
                //return 4742421;
                return 12456957;
            case ProductType.FLIGHT:
                return 0;
            default:
                //return 3534285;
                return 12454591;
        }
    };
    GeoTreeHelper.getTopDestinationsNodeId = function (productType) {
        switch (productType) {
            case ProductType.PACKAGE:
                //return 3534292;
                return 12454283;
            case ProductType.HOTEL:
                //return 4742348;
                return 12456833;
            case ProductType.RAIL_PACKAGE:
                //return 4742348;
                return 12456833;
            case ProductType.FLIGHT:
                return 0;
            default:
                //return 3534292;
                return 12454283;
        }
    };
    return GeoTreeHelper;
}());
export { GeoTreeHelper };
export default GeoTreeHelper;
